import styled, { keyframes } from 'styled-components';

/** دخول: من أسفل → أعلى + تلاشٍ دخول | خروج: من أعلى → أسفل + تلاشٍ خروج */
const fadeSlide = keyframes`
  0% {
    opacity: 0;
    transform: translateY(22px);
    animation-timing-function: cubic-bezier(0.22, 1, 0.36, 1);
  }
  16% {
    opacity: 1;
    transform: translateY(0);
    animation-timing-function: linear;
  }
  84% {
    opacity: 1;
    transform: translateY(0);
    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  }
  100% {
    opacity: 0;
    transform: translateY(20px);
  }
`;

export const Wrapper = styled.aside`
  position: fixed;
  z-index: 40;
  bottom: 100px;
  /* بداية السطر في RTL = يمين الشاشة، بعيداً عن واتساب (يسار ثابت) */
  inset-inline-start: max(16px, env(safe-area-inset-inline-start));
  /* مساحة زاوية مرجعية ثم عرض FOMO = ٧٥٪ منها فقط */
  width: calc(min(320px, calc(100vw - 32px)) * 0.75);
  max-width: calc(100vw - 32px);
  direction: rtl;
  pointer-events: none;
  box-sizing: border-box;

  @media (max-width: 768px) {
    bottom: 96px;
    inset-inline-start: max(12px, env(safe-area-inset-inline-start));
    width: calc(min(300px, calc(100vw - 24px)) * 0.75);
    max-width: calc(100vw - 24px);
  }
`;

export const Card = styled.div<{ $runAnimation: boolean; $durationSec: number }>`
  width: 100%;
  box-sizing: border-box;
  padding: 10px 12px;
  border-radius: 12px;
  background: oklch(1 0 0 / 0.96);
  border: 1px solid oklch(0.9288 0.0126 255.51);
  box-shadow:
    0 4px 24px oklch(0.2264 0 0 / 0.08),
    0 1px 2px oklch(0.2264 0 0 / 0.04);
  display: flex;
  align-items: flex-start;
  gap: 10px;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-font-smoothing: antialiased;
  
  /* تبديل translate3d بـ will-change لحل مشاكل الوميض والقص في Safari */
  will-change: transform, opacity;

  animation: ${(p) => (p.$runAnimation ? fadeSlide : 'none')}
    ${(p) => p.$durationSec}s linear both;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    opacity: 1;
  }
`;

export const IconWrap = styled.span`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background: oklch(0.65 0.24 33.09 / 0.12);
  color: var(--primary-color, oklch(0.65 0.24 33.09));
`;

export const TextBlock = styled.div`
  min-width: 0;
  flex: 1;
`;

export const Label = styled.p`
  margin: 0 0 2px 0;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: oklch(0.55 0.02 257);
  text-transform: uppercase;
`;

/** سطر واحد: اسم العميل + المنتج فقط، مع قصّ بنقاط عند الازدحام */
export const NameProductLine = styled.p`
  margin: 0;
  min-width: 0;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.35;
  color: oklch(0.2264 0 0);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ProductName = styled.span`
  color: oklch(0.45 0.02 257);
  font-weight: 500;
`;
